import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 2a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m.014 3.836A1 1 0 0 1 3 5h18a1 1 0 0 1 .986.836l1 6A1 1 0 0 1 22 13h-1v9a1 1 0 1 1-2 0v-9h-3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7H2a1 1 0 0 1-.986-1.164zM5 13v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7zm-1.82-2h17.64l-.667-4H3.847z"
    }, null, -1)
  ]))]))
}
export default { render: render }